import { styled } from 'styled-system/jsx'

const RowShell = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '16px',
    borderRadius: 'md',
    border: '1px solid',
    borderColor: '#EAE6F5',
    backgroundColor: '#FFFFFF',
  },
})

const RowHeader = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    flexWrap: 'wrap',
  },
})

const HeaderLeft = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
})

const HeaderRight = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap',
  },
})

const ExpandedArea = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '10px',
    flexWrap: 'wrap',
    paddingTop: '4px',
    borderTop: '1px solid',
    borderColor: '#F1EDFA',
  },
})

const FieldSlot = styled('div', {
  base: {
    flex: '1 1 220px',
    minWidth: '180px',
  },
})

const Message = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    lineHeight: '1.45',
    margin: '0',
    color: 'quickpass.inkSoft',
  },
})

export {
  RowShell,
  RowHeader,
  HeaderLeft,
  HeaderRight,
  ExpandedArea,
  FieldSlot,
  Message,
}
